<div class="card mb-3 border-0 shadow-sm">
  <div class="card-header bg-primary text-white d-flex align-items-center gap-2">
    <i class="bx bx-capsule bx-sm"></i>
    <strong>Medicamentos</strong>
    <span class="badge bg-light text-dark ms-auto">
      {{ administrations().length + requests().length + statements().length }}
    </span>
  </div>
  <div class="card-body">
    <!-- MedicationAdministration -->
    @if (administrations().length > 0) {
      <h6 class="text-muted mb-2">
        <i class="bx bx-injection"></i> Administraciones ({{ administrations().length }})
      </h6>
      <div class="table-responsive mb-3">
        <table class="table table-sm table-bordered mb-0">
          <thead class="table-light">
            <tr>
              <th>Medicamento</th>
              <th>Código</th>
              <th>Fecha</th>
              <th>Dosis</th>
              <th>Vía</th>
              <th>Estado</th>
            </tr>
          </thead>
          <tbody>
            @for (adm of administrations(); track adm.id) {
              <tr>
                <td>{{ getMedName(adm) }}</td>
                <td>
                  <code class="small">{{ getMedCode(adm) || '—' }}</code>
                </td>
                <td>{{ formatDate(adm.effectiveDateTime || adm.effectivePeriod?.start || '') }}</td>
                <td>{{ getDoseText(adm.dosage) }}</td>
                <td>{{ getRoute(adm.dosage) }}</td>
                <td>
                  @let badge = getStatusBadge(adm.status || '');
                  <span class="badge {{ badge.color }}">{{ badge.label }}</span>
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    }

    <!-- MedicationRequest -->
    @if (requests().length > 0) {
      <h6 class="text-muted mb-2">
        <i class="bx bx-file-blank"></i> Órdenes de Medicamento ({{ requests().length }})
      </h6>
      <div class="table-responsive mb-3">
        <table class="table table-sm table-bordered mb-0">
          <thead class="table-light">
            <tr>
              <th>Medicamento</th>
              <th>Código</th>
              <th>Fecha Orden</th>
              <th>Dosis</th>
              <th>Vía</th>
              <th>Frecuencia</th>
              <th>Estado</th>
            </tr>
          </thead>
          <tbody>
            @for (req of requests(); track req.id) {
              @let dosage = req.dosageInstruction?.[0];
              <tr>
                <td>{{ getMedName(req) }}</td>
                <td>
                  <code class="small">{{ getMedCode(req) || '—' }}</code>
                </td>
                <td>{{ formatDate(req.authoredOn || '') }}</td>
                <td>{{ getDoseText(dosage) }}</td>
                <td>{{ getRoute(dosage) }}</td>
                <td>{{ getFrequency(dosage) }}</td>
                <td>
                  @let badge = getStatusBadge(req.status || '');
                  <span class="badge {{ badge.color }}">{{ badge.label }}</span>
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    }

    <!-- MedicationStatement -->
    @if (statements().length > 0) {
      <h6 class="text-muted mb-2">
        <i class="bx bx-list-ul"></i> Declaraciones de Medicamento ({{ statements().length }})
      </h6>
      <div class="table-responsive">
        <table class="table table-sm table-bordered mb-0">
          <thead class="table-light">
            <tr>
              <th>Medicamento</th>
              <th>Código</th>
              <th>Estado</th>
            </tr>
          </thead>
          <tbody>
            @for (stmt of statements(); track stmt.id) {
              <tr>
                <td>{{ getMedName(stmt) }}</td>
                <td>
                  <code class="small">{{ getMedCode(stmt) || '—' }}</code>
                </td>
                <td>
                  @let badge = getStatusBadge(stmt.status || '');
                  <span class="badge {{ badge.color }}">{{ badge.label }}</span>
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    }

    @if (administrations().length === 0 && requests().length === 0 && statements().length === 0) {
      <p class="text-muted mb-0">Sin registros de medicamentos.</p>
    }
  </div>
</div>
